import React from 'react';
import FormField from '../FormField';

export default function AtividadesEconomicas() {
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre a situação atual das atividades econômicas do município, considerando agricultura, indústria, comércio, serviços e turismo.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="atividades_economicas_situacao"
          label="Situação atual"
          type="textarea"
          placeholder="Descreva a situação atual das atividades econômicas, considerando agricultura familiar, irrigação, cooperativas, assistência técnica, distritos industriais, segmentos produtivos, empregos, incentivos, varejo, atacado, serviços e turismo"
          helpText="Considere agricultura familiar, irrigação, cooperativas, assistência técnica, distritos industriais, segmentos produtivos, empregos, incentivos, varejo, atacado, serviços e turismo"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="atividades_economicas_indicadores"
          label="Principais indicadores"
          type="textarea"
          placeholder="Informe os principais indicadores encontrados para agricultura, indústria, comércio, serviços e turismo, como produtores ou estabelecimentos, área irrigada, cooperativas, empresas, empregos e fluxo turístico, sempre com ano e unidade de referência"
          helpText="Produtores ou estabelecimentos, área irrigada, cooperativas, empresas, empregos e fluxo turístico, sempre com ano e unidade de referência"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="atividades_economicas_problemas"
          label="Principais problemas identificados"
          type="textarea"
          placeholder="Descreva os principais problemas identificados nas atividades econômicas do município"
          helpText="Principais problemas identificados nas atividades econômicas do município"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="atividades_economicas_demandas"
          label="Demandas prioritárias identificadas"
          type="textarea"
          placeholder="Descreva as demandas prioritárias identificadas para fortalecimento da agricultura, indústria, comércio, serviços e turismo"
          helpText="Demandas prioritárias identificadas para fortalecimento da agricultura, indústria, comércio, serviços e turismo"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao6"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />

        <FormField
          name="links_acesso_secao6"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
